export const sidebar = (state = window.innerWidth > 1024, action) => {
  switch (action.type) {
    case "SHOW_SIDE_BAR":
      return action.data;
    default:
      return state;
  }
};
